import sizeItem from "./size.js"
import base from "../base.js";
import planBase from "./plan/planBase.js";
import planCreator from "./plan/creator.js";
import screenSize from "../definition/screenSize.js";
import { reactive } from 'vue'

export default class CompositionBuild extends base {
    objectType = "CompositionBuildItem";
    Size = null
    _Plans = [] //list plan item
    
    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        let plans = [];
        args = this.constructor.fromObjectToObject(args);
        if (args.size)
            args.size = sizeItem.fromObject({...args?.size, maxSizeX: -1, maxSizeY: -1});
        else
            args.size = new sizeItem({ largeur: screenSize.compositionWidth, hauteur: screenSize.compositionHeight, maxSizeX: -1, maxSizeY: -1 });
        if (args.plans) {
            for (const plan of args.plans) {
                plans.push(planCreator(plan.objectType, plan));
            }
        }
        args.plans = plans;
        super.objectToClassValue(args);
        this.Size = args.size ? args.size : null;
        if (this.Size) {
            this.Size.parent = this;
        }
        this.Plans = args.plans ? args.plans : [];
        this.CanBeRemove = false;
        this.CanBeHide = false;
    }

    set Plans(value) {
        this._Plans = reactive(value);
        if (this._Plans) {
            for (const plan of this._Plans) {
                plan.parent = this;
                plan.MaxSizeUpdated();
            }
        }
    }
    get Plans() {
        return this._Plans;
    }
    checkIsComplete(result = { isComplete: true, requiredBeforeSave: false, missingElements: [] }) {
        if (this.Size == null) {
            result.isComplete = false;
            result.requiredBeforeSave = true;
            result.missingElements.push("Taille de la composition");
        }
        if (this.Plans.some(plan => plan.objectType == "CameraPlanItem") == false) {
            result.isComplete = false;
            result.missingElements.push("Ajouter un plan de caméra (optionnel)");
        }
        return result;
    }
    get Name() {
        if (this.parent) {
            return this.parent.Name;
        }
        if (this._name) {
            return this._name;
        }
        return this.constructor.Name;
    }
    set Name(value) {
        if (this.parent && this.parent.Name != value) {
            this.parent.Name = value;
        }
        this._name = value;
    }
    static get Name() {
        return "Composition Build";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Size", type:"objectInput", dataType: "object", options: sizeItem, canBeAltered: false },
            { name: "Plans", type: "arrayInput", dataType: "object", options: planBase, elements: { name: "Plans", type: "objectInput", dataType: "object", options: planBase } },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Size", construct: sizeItem, jsType: "Class" },
            { property: "Plans", construct: planBase, jsType: "Array" },
        ];
    }

    getCompositionElementById(id) {
        if (this.Plans) {
            for (const plan of this.Plans) {
                let result = plan.getCompositionElementById(id);
                if (result != null) {
                    return result;
                }
            }
        }
        return null;
    }
    UpdateSize(width, height) {
        let beforeWidth = this.Size?.width ? this.Size.width : width;
        let beforeHeight = this.Size?.height ? this.Size.height : height;
        if (this.Size) {
            this.Size.width = width;
            this.Size.height = height;
        }
        for (const plan of this.Plans) {
            plan.MaxSizeUpdated(beforeWidth, beforeHeight);
        }
    }
    removeFromBuild(previewId) {
        if (this.Plans) {
            this.Plans.some((plan, index) => {
                if (plan.previewId == previewId) {
                    this.Plans.splice(index, 1);
                    return true;
                }
                return plan.removeFromPlan(previewId);
            });
        }
        return false;
    }
    swapArrayElement(index, move) {
        if (index < 0 || index > this.Plans.length) return;
        this.Plans.splice(index + move, 0, this.Plans.splice(index, 1)[0]);
    }
    getStyle(currentElementIndex = null) {
        return {
            ...super.getStyle(currentElementIndex),
        };
    }
    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            size: this.Size ? this.Size.toExportObject() : null,
            plans: this.Plans.length > 0 ? this.Plans.map(plan => plan.toExportObject()) : [],
        }
    }
    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            size: this.Size ? this.Size.toObject(minify) : null,
            plans: this.Plans.length > 0 ? this.Plans.map(plan => plan.toObject(minify)) : [],
        }
    }
    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        return null;
    }
}
